export enum PaymentVendorEnum {
  BlueMedia = 'blueMedia',
  Internal = 'internal',
}
